import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function PickupArrivalDetails({ label, options, time, onChange, isEditable }) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={time}
                options={options}
                onSave={onChange}
                isEditable={isEditable}
            />
        </EuiFlexItem>
    );
}
